const createMarkup = (__html) => {
  return { __html };
};

export default createMarkup;